/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdDrawerProps } from './type';

export const drawerDefaultProps: TdDrawerProps = {
  closeOnEscKeydown: undefined,
  closeOnOverlayClick: undefined,
  closeBtn: true,
  destroyOnClose: false,
  footer: true,
  forceRender: false,
  header: true,
  mode: 'overlay',
  placement: 'right',
  preventScrollThrough: true,
  showInAttachedElement: false,
  showOverlay: true,
  size: undefined,
  sizeDraggable: false,
  visible: false,
};
